import { render, staticRenderFns } from "./muestraCrear.vue?vue&type=template&id=5ab00e1f&scoped=true"
import script from "./muestraCrear.vue?vue&type=script&lang=js"
export * from "./muestraCrear.vue?vue&type=script&lang=js"
import style0 from "./muestraCrear.vue?vue&type=style&index=0&id=5ab00e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab00e1f",
  null
  
)

export default component.exports